
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div className='title'>So wird bestimmt, wo die Gefahrengebiete liegen</div>
    <p>{`Ob ein Gebiet als gefährdet eingestuft wird, hängt davon ab, wie häufig und mit welcher Intensität Ereignisse wie Überschwemmungen oder Lawinen auftreten. Die Einteilung erfolgt anhand eines Intensitäts-Wahrscheinlichkeits-Diagramms:`}</p>
    <div className='imageContainer'>
  <img className='visual' src='images/matrix.svg' width='250px' />
    </div>
    <b>Intensität:</b><br />Graduelle Prozesse wie der steigende Pegel eines Sees nach lang anhaltenden Niederschlägen sind für Menschen weniger gefährlich als sogenannte «brutale» Ereignisse, die ohne grosse Vorwarnzeit auftreten können. Beispiele für brutale Prozesse sind ein Felssturz oder ein Gebirgsbach, der nach einem lokalen Gewitter plötzlich über die Ufer tritt.
    <b>Wahrscheinlichkeit:</b><br />Beim Erstellen von Gefahrenkarten wird unterschieden zwischen Ereignissen, die voraussichtlich alle 30, 100 oder 300 Jahre eintreten. Eine Zone kann auch dann als erheblich gefährdet eingestuft werden, wenn ein bestimmtes Ereignis nur alle 300 Jahre auftritt.
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;